import api from './api'

const sosItemService = {
  async search(query) {
    const response = await api.get('/sos-items/search', {
      params: { q: query }
    })
    return response.data
  },

  async refreshCache() {
    const response = await api.post('/sos-items/refresh')
    return response.data
  },

  async getCacheStatus() {
    const response = await api.get('/sos-items/cache-status')
    return response.data
  }
}

export default sosItemService
